<template>
    <el-card class="full-width" v-loading="loading">
        <el-row>
            <el-col :span="10" class="label-part">
                <font-awesome-icon icon="fa-regular fa-building" />
            </el-col>
            <el-col :span="14" class="text-part">
                {{addressBook.addinfo4}}
            </el-col>

            <el-col :span="10" class="label-part">
                <font-awesome-icon icon="fa-regular fa-user" />
            </el-col>
            <el-col :span="14" class="text-part">
                {{addressBook.addinfo1}}
            </el-col>

            <el-col :span="10" class="label-part">
                <font-awesome-icon icon="fa-regular fa-envelope" />
            </el-col>
            <el-col :span="14" class="text-part">
                {{addressBook.addinfo2}}
            </el-col>

            <el-col :span="10" class="label-part">
                <font-awesome-icon icon="fa-solid fa-phone" />
            </el-col>
            <el-col :span="14" class="text-part">
                {{addressBook.addinfo3}}
            </el-col>

            <el-col :span="24">
                <div class="operation-box">
                    <el-button
                        type="primary"
                        link
                        @click="clickInvite"
                    >
                        <span tkey="邀請">{{i18n.tkey("lang_invite")}}</span>
                    </el-button>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button
                        type="danger"
                        link
                        @click="clickDelete"
                    >
                        <span tkey="刪除">{{i18n.tkey("lang_delete")}}</span>
                    </el-button>
                </div>
            </el-col>
        </el-row>
    </el-card>

    <a :href="invUrl" ref="inviteATag" style="display:none;"></a>
</template>

<script setup>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faBuilding, faUser, faEnvelope } from '@fortawesome/free-regular-svg-icons'
    import { faPhone } from '@fortawesome/free-solid-svg-icons'
    import {getCurrentInstance, inject, onMounted, ref, toRef} from "vue";
    import api from "@/request/api"
    import util from "@/util/util"
    import {ElMessageBox} from "element-plus";
    import {useCardinfo} from "@/stores/cardinfo";
    // import {useCompanyinfo} from "@/stores/companyinfo";
    import {useUserinfo} from "@/stores/userinfo";

    const { proxy } = getCurrentInstance()

    library.add(faBuilding, faUser, faEnvelope, faPhone)

    const props = defineProps(["addressBook", "objIndex"])
    const emits = defineEmits(["deleteSuccess"])

    const i18n = inject("i18n")

    const cardInfoRef = toRef(useCardinfo())
    // const companyInfoRef = toRef(useCompanyinfo())
    const userInfoRef = toRef(useUserinfo())

    const invUrl = ref("")
    const loading = ref(false)

    function clickDelete() {
        ElMessageBox.confirm(i18n.tkey("lang_delete_confirm"), {
            confirmButtonText: i18n.tkey("lang_sure"),
            cancelButtonText: i18n.tkey("lang_cancel"),
        })
        .then(() => {
            deleteFunc()
        })
        .catch(() => {
            // catch error
        })
    }

    function deleteFunc() {
        if (null != props.addressBook.id){
            const submitObj = api.delAdditionalrecord9.getParams()

            submitObj.id = props.addressBook.id

            api.delAdditionalrecord9.send(submitObj, deleteCallback)
        }
    }

    function deleteCallback(res) {
        if (res.code === 200){
            util.alertSuccess(i18n.tkey("lang_delete_success"),)
            emits("deleteSuccess", props.objIndex)
        }else{
            util.alertError(res.msg)
        }
    }

    function clickInvite() {
        if (util.isEmpty(props.addressBook.addinfo2)){
            if (util.isMobile()){
                ElMessageBox.confirm(i18n.tkey("lang_send_sms_confirm"), {
                    confirmButtonText: i18n.tkey("lang_sure"),
                    cancelButtonText: i18n.tkey("lang_cancel"),
                })
                .then(() => {
                    const url = `${location.origin}/account_page?operation=signup&isAllow=1&varName=id&loc=receive&value=${cardInfoRef.value.id}`
                    const msg = `來自${userInfoRef.value.companyname}的${userInfoRef.value.name}，現邀請您上 Shopopee 進行專業的商業溝通!可免費創建業務/活動/組織群組，以及獲贈促銷網點：發佈產品推廣，發現業務合作商機。點擊鏈接註冊後即可交換名片：${url}`

                    invUrl.value = `sms:${props.addressBook.addinfo3}?body=${msg}`
                    proxy.$refs.inviteATag.click()
                })
                .catch(() => {
                    // catch error
                })
            }else{
                util.alertWarning(i18n.tkey("lang_email_none_text"))
            }
        }else{
            const obj = api.sendNewEmailByAddinfo9.getParams()
            obj.id = props.addressBook.id
            obj.memberworkId = cardInfoRef.value.id
            obj.companyname = userInfoRef.value.companyname
            obj.name = userInfoRef.value.name

            loading.value = true
            api.sendNewEmailByAddinfo9.send(obj, clickCallback)

        }
    }

    function clickCallback(res) {
        loading.value = false
        if (res.code == 201){
            util.alertWarning(i18n.tkey("lang_user_repeat"))
        }else if (res.code == 202){
            util.alertWarning(i18n.tkey("lang_send_addinfo9_error_1"))
        }else{
            util.alertSuccess(i18n.tkey("lang_invite_success"))
        }
    }
</script>

<style scoped>
    .full-width {
        width: 100%;
        text-align: center;
        line-height: 2;
    }

    .operation-box {
        line-height: 4;
    }

    .label-part {
        color: #606266;
        /*text-align: right;*/
        /*padding-right: 1em;*/
    }

    .text-part {
        color: #303133;
        /*text-align: left;*/
        /*padding-left: 1em;*/
    }
</style>